import {
  createContext,
  useContext,
  useMemo,
  useRef,
  type ReactNode,
} from 'react';

type SubLevelCoordinator = {
  register: (id: symbol, close: () => void) => void;
  unregister: (id: symbol) => void;
  notifyOpened: (id: symbol) => void;
};

const MenuSubLevelContext = createContext<SubLevelCoordinator | null>(null);

export function useMenuSubLevelCoordinator(): SubLevelCoordinator | null {
  return useContext(MenuSubLevelContext);
}

export function MenuSubLevelProvider({ children }: { children: ReactNode }) {
  const subsRef = useRef(new Map<symbol, () => void>());
  const coordinator = useMemo<SubLevelCoordinator>(
    () => ({
      register: (id, close) => {
        subsRef.current.set(id, close);
      },
      unregister: (id) => {
        subsRef.current.delete(id);
      },
      notifyOpened: (id) => {
        subsRef.current.forEach((close, subId) => {
          if (subId !== id) {
            close();
          }
        });
      },
    }),
    [],
  );

  return (
    <MenuSubLevelContext.Provider value={coordinator}>
      {children}
    </MenuSubLevelContext.Provider>
  );
}
